import Script from 'next/script';

import { parseToBool } from 'lib/string';
import { markup } from 'lib/utils';

import APP from 'constants/app';

// Requires and injects gtag.js script in production mode
// See: https://github.com/vercel/next.js/tree/canary/examples/with-google-analytics
function GoogleTagManager() {
  if (!parseToBool(process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ENABLED)) {
    return null;
  }

  return (
    <>
      <Script
        id="gtag-script-url"
        strategy="afterInteractive"
        src={`${APP.GOOGLE_TAG_MANAGER_URL}?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}`}
      />
      <Script
        id="gtag-init-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={markup(`
          window.dataLayer=window.dataLayer||[];function gtag(){window.dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}',{custom_map:{dimension2:'version'}});
        `)}
      />
    </>
  );
}

export default GoogleTagManager;
